
import Vue from 'vue'
import ServerPaginationList from '@/components/ServerPaginationList.vue'
import ArticleCardItem from '@/components/article/CardItem.vue'

export default Vue.extend({
  name: 'Learn',
  components: {
    ServerPaginationList,
    ArticleCardItem,
  },
  data: () => ({}),
})
